<template>
  <span>
    <v-btn
      class="track-order-button"
      @click="setSelectedOrderNumber(orderId)"
      height="40"
      color="secondary"
    >
      <status-delivering :tracking-button="true" />
      <span class="text">Track Order</span>
    </v-btn>
  </span>
</template>

<script>
import StatusDelivering from "@/assets/order_status/delivering.vue";

export default {
  name: "BringgTrackingButton",
  components: {
    StatusDelivering,
  },
  props: {
    orderId: Number,
  },
  methods: {
    setSelectedOrderNumber(orderId) {
      this.$store.dispatch("orderStatus/updateCurrentOrderNumber", orderId);
    },
  },
};
</script>

<style scoped>
.track-order-button {
  font-size: 14px;
  border-radius: 62px;
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.16);
  width: 148px;
}

@media (min-width: 960px) and (max-width: 1160px) {
  .track-order-button {
    width: 125px;
  }
  .text {
    font-size: 11px;
  }
}
</style>
